import React, { useCallback } from 'react';

import {
    formatNumber,
    getLocationWithoutCampa,
} from 'js/components/shared/vehicleFunctions';
import { vehicleStateEnum } from 'enums/VehicleStateEnum';

import pinSvg from 'images/icons/pin-icon.svg';

const vehicleRetiredStates = Object.freeze([
    vehicleStateEnum.SOLD_PENDING_PAYMENT,
    vehicleStateEnum.SOLD_PENDING_DOCUMENTATION,
    vehicleStateEnum.SOLD_AND_TRANSFERRED,
]);

const VehicleDescription = ({ vehicle, t }) => {
    const printLocationText = useCallback(() => {
        if (vehicle.RepurchaseObligation >= 0) {
            return vehicle.DealerReturn.Description;
        } else {
            if (vehicle?.Origin?.Description || vehicle.OriginDescription) {
                return vehicle?.Origin?.Description || vehicle.OriginDescription
            }
        }
        const isVehicleRetired = vehicleRetiredStates.includes(
            String(vehicle.CodeTypeStateVehicle)
        );

        return t.getTraduction(
            isVehicleRetired ? 'VehicleRetired' : 'WithoutLocation'
        );
    }, [vehicle, t]);
    return (
        <div className="o-layout u-mb-small">
            <div className="o-layout__item u-1/1 u-mt-none u-mb-small">
                <ul className="c-detail-vehicle__details-list  ">
                    {vehicle.MoreDetails.RegistrationDate ? (
                        <li> {vehicle.MoreDetails.RegistrationDate} </li>
                    ) : (
                        ''
                    )}
                    {vehicle.MoreDetails.Kilometers ? (
                        <li>
                            {' '}
                            {formatNumber(
                                vehicle.MoreDetails.Kilometers
                            )} Km{' '}
                        </li>
                    ) : (
                        ''
                    )}
                    {vehicle.MoreDetails.HorsePower ? (
                        <li> {vehicle.MoreDetails.HorsePower} CV </li>
                    ) : (
                        ''
                    )}
                    {vehicle.MoreDetails.EnergyTypeName ? (
                        <li> {vehicle.MoreDetails.EnergyTypeName} </li>
                    ) : (
                        ''
                    )}
                    {vehicle.MoreDetails.Transmission ? (
                        <li> {vehicle.MoreDetails.Transmission}</li>
                    ) : (
                        ''
                    )}
                </ul>
            </div>
            <div className="o-layout__item u-1/1 u-mt-none c-detail-vehicle__info-icon u-pt">
                <span
                    className={
                        vehicle.MoreDetails.ProvinceZone === 'C'
                            ? 'rema-canary-background--block'
                            : ''
                    }
                >
                    <img
                        className="rema-img-icon"
                        src={pinSvg}
                        alt="Rema icon"
                    />
                    {printLocationText()}
                </span>
            </div>
            <div className="o-layout__item u-1/1 u-mt-none u-pt">
                <span>
                    <i
                        className={`c-icon c-icon--[document-${vehicle?.MoreDetails?.ExistBill
                                ? 'lines-checkmark'
                                : 'circle-cross'
                            }] rema-img-icon`}
                        aria-hidden="true"
                        role="img"
                    />
                    {t.getTraduction('BillIncludedLabel')(
                        vehicle?.MoreDetails?.ExistBill
                    )}
                </span>
            </div>
        </div>
    );
};

export default VehicleDescription;
